// Dashboard entry point - Full functionality for user dashboard

// Import core functionality with relative paths
// Note: version.js import removed as it depends on window.staticVersion which isn't set in Vite

// Essential functions that don't have complex dependencies first
window.questus = window.questus || {};

// Basic loading overlay management
window.questus.hideLoadingOverlay = function() {
  const overlay = document.getElementById('loadingOverlay');
  if (overlay) {
    overlay.style.display = 'none';
  }
  document.body.classList.remove('loading');
};

window.questus.updateOverlayMessage = function(message) {
  const messageElement = document.getElementById('loadingMessage');
  if (messageElement) {
    messageElement.textContent = message;
  }
};

// Navigation function is now defined globally in base_vite.html
// No need to redefine it here

// HTMX event listeners
function addHTMXListeners() {
  document.body.addEventListener('htmx:beforeRequest', () => {
    const overlay = document.getElementById('loadingOverlay');
    if (overlay) overlay.style.display = 'flex';
  });

  document.body.addEventListener('htmx:afterRequest', () => {
    window.questus.hideLoadingOverlay();
  });

  document.body.addEventListener('htmx:afterSwap', (event) => {
    if (event.detail.target.id === 'content') {
      // Re-initialize components after content swap
      
      // Handle folder panel visibility based on response headers
      const xhr = event.detail.xhr;
      if (xhr) {
        const showFolderPane = xhr.getResponseHeader('HX-Show-Folder-Pane');
        const folderPanel = document.getElementById('folder-panel');
        
        if (folderPanel) {
        }
        
        if (folderPanel && showFolderPane !== null) {
          if (showFolderPane === 'true') {
            folderPanel.style.display = 'flex';
          } else if (showFolderPane === 'false') {
            folderPanel.style.display = 'none';
          }
        } else {
        }
      }
      
      // Call page-specific initialization if available
      if (typeof window.pageInitialization === 'function') {
        window.pageInitialization();
      }
    }
  });
}

// Bootstrap event listeners
function addBootstrapListeners() {
  // Handle tab switching
  const tabLinks = document.querySelectorAll('[data-bs-toggle="tab"]');
  tabLinks.forEach(link => {
    link.addEventListener('shown.bs.tab', function(e) {
      const targetId = e.target.getAttribute('data-bs-target');
      localStorage.setItem('activeTab', targetId);
    });
  });
}

// Note: Folder tree initialization is now handled globally in global.js
// We don't need to import loadAllData here anymore

// Screen size handling
function checkScreenSize() {
  const folderPanel = document.getElementById('folder-panel');
  if (folderPanel) {
    if (window.innerWidth < 992) {
      folderPanel.style.display = 'none';
    } else {
      folderPanel.style.display = 'flex';
    }
  }
}

// Initialize global folder data placeholder
window.gFolderData = window.gFolderData || {};

async function initDashboard() {
  
  try {
    // Add event listeners
    addHTMXListeners();
    addBootstrapListeners();
    
    // Folder tree is now initialized globally in global.js
    // No need to load data or populate tree here
    
    // Handle responsive layout
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    // Offcanvas sidebar movement is now handled globally in sidebar.html
    
    // Hide loading overlay
    window.questus.hideLoadingOverlay();
    
    
  } catch (error) {
    console.error('❌ Dashboard initialization failed:', error);
    window.questus.hideLoadingOverlay();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDashboard);
} else {
  initDashboard();
}